<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <CoolSelect
                  v-if="n_user.n_current_user.IsSU"
                  v-model="n_user.n_user_edit.UserGroupID"
                  placeholder="Group"
                  theme="bootstrap"
                  tooltip="Group"
                  :items="n_user.n_usergroups"
                  item-text="UserGroupName"
                  item-value="UserGroupID"
                  id="UserGroupID"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Group</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                  <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
                  </template>-->
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Email Address</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.UserName.$error }"
                    v-model="n_user.n_user_edit.UserName"
                    placeholder="Required"
                    autocomplete="off"
                    type="text"
                    id="UserName"
                    @input="$v.n_user.n_user_edit.UserName.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-user appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Password</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.Password.$error }"
                    v-model="n_user.n_user_edit.Password"
                    autocomplete="off"
                    placeholder="Required"
                    type="password"
                    id="Password"
                    v-on:change.native="addDirtyField"
                    @input="$v.n_user.n_user_edit.Password.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i
                        @click="togglePassword()"
                        class="fa fa-eye appendIcon clickIcon"
                      ></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >First Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.FirstName.$error }"
                    v-model="n_user.n_user_edit.FirstName"
                    placeholder="Required"
                    type="text"
                    id="FirstName"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.n_user.n_user_edit.FirstName.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Last Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.LastName.$error }"
                    v-model="n_user.n_user_edit.LastName"
                    placeholder="Required"
                    type="text"
                    id="LastName"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.n_user.n_user_edit.LastName.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Address</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.Address1.$error }"
                    v-model="n_user.n_user_edit.Address1"
                    placeholder="Required"
                    type="text"
                    id="Address1"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.n_user.n_user_edit.Address1.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Building/Suite</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.Address2"
                    type="text"
                    id="Address2"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >City</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.City.$error }"
                    v-model="n_user.n_user_edit.City"
                    placeholder="Required"
                    type="text"
                    id="City"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.n_user.n_user_edit.City.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >State/Province</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.State.$error }"
                    v-model="n_user.n_user_edit.State"
                    placeholder="Required"
                    type="text"
                    id="State"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.n_user.n_user_edit.State.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Postal Code</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.Zip.$error }"
                    v-model="n_user.n_user_edit.Zip"
                    placeholder="Required"
                    type="text"
                    id="Zip"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.n_user.n_user_edit.Zip.$touch()"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Country</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.Country"
                    type="text"
                    id="Country"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-address-book appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Phone</b-input-group-text
                    >
                  </b-input-group-prepend>

                  <b-form-input
                    :class="{ testred: $v.n_user.n_user_edit.Phone1.$error }"
                    v-model="n_user.n_user_edit.Phone1"
                    placeholder="Required"
                    type="text"
                    id="Phone1"
                    v-mask="'(###) ###-####'"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.n_user.n_user_edit.Phone1.$touch()"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Mobile</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_user_edit.Phone2"
                    type="text"
                    v-mask="'(###) ###-####'"
                    id="Phone2"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="6">
              <b-form-radio-group
                class="mr-3"
                id="radiosBtn"
                buttons
                button-variant="outline-primary"
                v-model="n_user.n_user_edit.IsSU"
                @change.native="addDirtyFieldRadio"
                name="radiosBtn"
              >
                <b-form-radio class="mx-0 longStandardizedRadioWidth" value="true">Administrator</b-form-radio>
                <b-form-radio class="mx-0 longStandardizedRadioWidth" value="false">Client Care</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row> -->

          <div class="form-group form-actions" style="float:left;">
            <!-- <b-button
              v-if="
                n_user.n_user_edit.UserProfileID != -1 &&
                  n_user.n_user_edit.UserGroupID !== 2
              "
              class="mr-2 mt-2"
              style="color: white;"
              size="md"
              variant="green active"
              @click="DashRouteTo('/points/ledger')"
            >
              <i class="fa fa-dollar"></i>
              Reward Points</b-button
            > -->
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-button
              class="mr-2 mt-2"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Cancel
            </b-button>
            <b-button
              class="mr-0 mt-2"
              size="md"
              variant="primary"
              type="submit"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="(dismissCountdown = 0)"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss2Countdown = 0)"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss3CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss3Countdown = 0)"
              @dismiss-count-down="countDown3Changed"
            >
              User already exists! Your information could not be saved.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
          <b-row class="mt-4">
            <b-col md="12"> </b-col>
          </b-row>
          <b-row class="mt-4" v-if="n_user.n_current_user.IsSU">
            <b-col lg="12">
              <b-tabs style="width: 100%;">
                <b-tab active class="full-width">
                  <template slot="title">
                    <div class="standardizedWidth" style="text-align: center;">
                      <h3>Dealers</h3>
                    </div>
                  </template>
                  <b-row class="mt-4">
                    <b-col lg="12">
                      <h3>Access By Dealer</h3>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-table
                        @row-clicked="myRowClickHandler"
                        :items="n_user.n_user_edit.Manages"
                        :fields="fields"
                        hover
                        small
                        fixed
                        caption
                        selectable
                        select-mode="single"
                        responsive="sm"
                        selectedVariant="success"
                      >
                        <template slot="Functions" slot-scope="data">
                          <i
                            v-b-tooltip
                            title="Remove"
                            class="fa fa-minus-circle localMinusSign"
                            @click.stop="SetItemToRemove(data.item, false)"
                          ></i>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col md="12">
                      <h2></h2>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-form-group>
                        <b-input-group>
                          <b-form-input
                            type="text"
                            placeholder="Search"
                            @keyup="filterList"
                            v-model="searchString"
                          />

                          <b-input-group-append>
                            <b-input-group-text>
                              <i
                                class="fa fa-times appendIcon clickIcon"
                                @click="resetSearch"
                              ></i>
                            </b-input-group-text>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-table
                        @row-clicked="myRowClickHandler"
                        :items="filteredObjects"
                        :fields="fields"
                        hover
                        small
                        fixed
                        caption
                        selectable
                        select-mode="single"
                        responsive="sm"
                        selectedVariant="success"
                        :current-page="currentPage"
                        :per-page="perPage"
                      >
                        <template slot="Functions" slot-scope="data">
                          <i
                            v-b-tooltip
                            title="Add"
                            class="fa fa-plus-circle localPlusSign"
                            @click.stop="SetItemToAdd(data.item, false)"
                          ></i>
                        </template>
                      </b-table>

                      <nav v-show="isNavVisible">
                        <b-pagination
                          :per-page="perPage"
                          :total-rows="totalRowsFiltered"
                          v-model="currentPage"
                          prev-text="Prev"
                          next-text="Next"
                          hide-goto-end-buttons
                        />
                      </nav>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <div class="standardizedWidth" style="text-align: center;">
                      <h3>Dealer Groups</h3>
                    </div>
                  </template>
                  <b-row class="mt-4">
                    <b-col lg="12">
                      <h3>Access By Dealer Group</h3>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-table
                        @row-clicked="myRowClickHandlerGroup"
                        :items="n_user.n_user_edit.ManagedGroups"
                        :fields="fields_group"
                        hover
                        small
                        fixed
                        caption
                        selectable
                        select-mode="single"
                        responsive="sm"
                        selectedVariant="success"
                      >
                        <template slot="Functions" slot-scope="data">
                          <i
                            v-b-tooltip
                            title="Remove"
                            class="fa fa-minus-circle localMinusSign"
                            @click.stop="SetItemToRemove(data.item, true)"
                          ></i>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col md="12">
                      <h2></h2>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-form-group>
                        <b-input-group>
                          <b-form-input
                            type="text"
                            placeholder="Search"
                            @keyup="filterList"
                            v-model="searchString"
                          />

                          <b-input-group-append>
                            <b-input-group-text>
                              <i
                                class="fa fa-times appendIcon clickIcon"
                                @click="resetSearch"
                              ></i>
                            </b-input-group-text>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-table
                        @row-clicked="myRowClickHandlerGroup"
                        :items="filteredGroupObjects"
                        :fields="fields_group"
                        hover
                        small
                        fixed
                        caption
                        selectable
                        select-mode="single"
                        responsive="sm"
                        selectedVariant="success"
                        :current-page="currentPage"
                        :per-page="perPage"
                      >
                        <template slot="Functions" slot-scope="data">
                          <i
                            v-b-tooltip
                            title="Add"
                            class="fa fa-plus-circle localPlusSign"
                            @click.stop="SetItemToAdd(data.item, true)"
                          ></i>
                        </template>
                      </b-table>

                      <nav v-show="isNavVisibleGroup">
                        <b-pagination
                          :per-page="perPage"
                          :total-rows="totalRowsGroupFiltered"
                          v-model="currentPage"
                          prev-text="Prev"
                          next-text="Next"
                          hide-goto-end-buttons
                        />
                      </nav>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EmployeeCard from "@/components/cards/EmployeeCard.vue";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "UserProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false,
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "Name",
          label: "Name",
          sortable: true,
          thStyle: "width: 25%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "State",
          label: "State",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "PostalCode",
          label: "Zip",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "InternalDealerID",
          label: "BDS ID",
          sortable: true,
          thStyle: "width: 35%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      fields_group: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "Name",
          label: "Name",
          sortable: true,
          thStyle: "width: 25%;"
        },
        {
          key: "Notes",
          label: "Notes",
          sortable: true,
          thStyle: "width: 70%;"
        }
      ],
      selected: [], // Must be an array reference!,
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      filteredGroupObjects: [],
      searchString: ""
    };
  },
  created() {
    this.myLoadComponent();
  },
  methods: {
    myRowClickHandler(record, index, event) {
      this.$store
        .dispatch("dealer/loadDealerEdit", record.DealershipID)
        .then(() => {
          this.$router.push({ name: "DealerProfile" });
        });
    },
    myRowClickHandlerGroup(record, index, event) {
      this.$store
        .dispatch("dealer/loadDealerGroupEdit", record.DealerGroupID)
        .then(() => {
          this.$router.push({ name: "DealerGroupProfile" });
        });
    },
    async SetItemToAdd(object, isGroup) {
      if (isGroup) {
        this.$store.state.n_user.n_user_edit.ManagedGroups.push(object);
        var _op = {
          UserProfileID: this.$store.state.n_user.n_user_edit.UserProfileID,
          DealerGroupID: object.DealerGroupID,
          DealershipID: -1,
          Include: true
        };
        await this.$store.dispatch("n_user/adjustUserPermissions", _op);
      } else {
        this.$store.state.n_user.n_user_edit.Manages.push(object);
        var _op = {
          UserProfileID: this.$store.state.n_user.n_user_edit.UserProfileID,
          DealerGroupID: -1,
          DealershipID: object.DealershipID,
          Include: true
        };
        await this.$store.dispatch("n_user/adjustUserPermissions", _op);
      }
      this.filterList();
    },
    async SetItemToRemove(object, isGroup) {
      if (isGroup) {
        this.$store.state.n_user.n_user_edit.ManagedGroups = this.$store.state.n_user.n_user_edit.ManagedGroups.filter(
          d => d.DealerGroupID !== object.DealerGroupID
        );
        var _op = {
          UserProfileID: this.$store.state.n_user.n_user_edit.UserProfileID,
          DealerGroupID: object.DealerGroupID,
          DealershipID: -1,
          Include: false
        };
        await this.$store.dispatch("n_user/adjustUserPermissions", _op);
      } else {
        this.$store.state.n_user.n_user_edit.Manages = this.$store.state.n_user.n_user_edit.Manages.filter(
          d => d.DealershipID !== object.DealershipID
        );
        var _op = {
          UserProfileID: this.$store.state.n_user.n_user_edit.UserProfileID,
          DealerGroupID: -1,
          DealershipID: object.DealershipID,
          Include: false
        };
        await this.$store.dispatch("n_user/adjustUserPermissions", _op);
      }
      this.filterList();
    },
    filterList: function() {
      this.filteredObjects = this.NotIncluded;
      this.filteredGroupObjects = this.NotIncludedGroups;

      this.filteredObjects = this.filteredObjects.filter(
        dealer =>
          dealer.Name.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          dealer.InternalDealerID.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          dealer.State.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          dealer.PostalCode.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );

      this.filteredGroupObjects = this.filteredGroupObjects.filter(
        group =>
          group.Name.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          group.Notes.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    async myLoadComponent() {
      await this.$store.dispatch("n_user/fetchUserGroups");
      this.filterList();
    },
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    saveTest() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/Save", {
            _saveOp: {
              Url: "/User/SaveUser/",
              Data: {
                _up: this.$store.state.n_user.n_user_edit,
                _newValues: this.dirtyFields,
                ReturnMap: this.$store.state.n_user.n_user_edit.UserProfileID
              }
            }
          })
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );
      }
    },
    saveTest2() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.SaveOperation = {
          Url: "/User/SaveUser/",
          Data: {
            _up: this.$store.state.n_user.n_user_edit,
            _newValues: this.dirtyFields,
            ReturnMap: this.$store.state.n_user.n_user_edit.UserProfileID
          }
        };
        this.$store
          .dispatch("saveOp/EmitSave")
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );
      }
    },
    async save() {
      if (
        this.$store.state.n_user.n_users.find(
          user =>
            user.UserProfileID !==
              this.$store.state.n_user.n_user_edit.UserProfileID &&
            user.UserName.toLowerCase() ===
              this.$store.state.n_user.n_user_edit.UserName.toLowerCase()
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      //double check the database
      if (this.$store.state.n_user.n_user_edit.UserProfileID === -1) {
        var _existing_id = -1;

        await this.$store
          .dispatch(
            "n_user/doesUserExist",
            this.$store.state.n_user.n_user_edit.UserName
          )
          .then(response => {
            _existing_id = response.data["DoesUserNameExistResult"];
          });

        if (_existing_id > -1) {
          this.dismiss3CountDown = this.dismiss3Secs;
          return;
        }
      }

      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.localUrl = "/User/SaveUser/";
        this.$store.state.saveOp.localVariableName = "_up";
        this.$store.state.saveOp.localVariableObject = this.$store.state.n_user.n_user_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "UserProfileID";
        this.$store.state.saveOp.localReturnObject = "SaveUserResult";
        //this.$store.state.n_user.n_user_edit[:UserProfileID];

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        this.$store.dispatch("n_user/fetchUsers");
        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    saveOriginal() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("n_user/Save", {
            user: this.$store.state.n_user.n_user_edit,
            fields: this.dirtyFields
          })
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );

        //.then(alert(this.$store.state.n_user.n_user_edit.UserProfileID));
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
      }
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    togglePassword: function() {
      const passwordField = document.querySelector("#Password");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
    DashRouteTo(_page) {
      this.save();
      this.$router.push(_page);
    }
  },
  computed: {
    ...mapState(["n_user", "dealer", "saveOp"]),
    ...mapActions("n_user", ["Save"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    totalRows: function() {
      return this.$store.state.n_user.n_user_edit.Manages.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    totalRowsGroup: function() {
      return this.$store.state.n_user.n_user_edit.ManagedGroups.length;
    },
    totalRowsGroupFiltered: function() {
      return this.filteredGroupObjects.length;
    },
    isNavVisibleGroup: function() {
      return this.totalRowsGroupFiltered > this.perPage;
    },
    NotIncluded() {
      var _ni = this.$store.state.dealer.dealers;
      this.$store.state.n_user.n_user_edit.Manages.forEach(m => {
        _ni = _ni.filter(ni => ni.DealershipID != m.DealershipID);
      });
      return _ni;
    },
    NotIncludedGroups() {
      var _nig = this.$store.state.dealer.dealergroups;
      this.$store.state.n_user.n_user_edit.ManagedGroups.forEach(g => {
        _nig = _nig.filter(nig => nig.DealerGroupID != g.DealerGroupID);
      });
      return _nig;
    }
  },
  components: {
    EmployeeCard,
    CoolSelect
  },
  validations: {
    n_user: {
      n_user_edit: {
        UserName: {
          required,
          email
          //minLength: minLength(7)
        },
        Password: {
          required
        },
        FirstName: {
          required
        },
        LastName: {
          required
        },
        Address1: {
          required
        },
        City: {
          required
        },
        State: {
          required
        },
        Zip: {
          required,
          minLength: minLength(5)
        },
        Phone1: {
          required,
          minLength: minLength(14)
        }
      }
    }
  },
  watch: {
    "$store.state.n_user.n_user_edit.UserGroupID": function() {
      this.addDirtyFieldWatch(
        "UserGroupID",
        this.$store.state.n_user.n_user_edit.UserGroupID
      );
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.testred {
  color: red;
  border-color: red;
}
.full-width .nav-tabs .nav-item {
  margin-bottom: -1px;
  flex-grow: 1;
  text-align: center;
}
.full-width .card-header-tabs {
  margin-right: -21px;
  margin-left: -21px;
}
</style>
